import React from "react";
import { Alert, Card, GridLegacy } from "@mui/material";
import FormTextTC from "../../../../../components/Forms/FormTextTC";
import { DialogProvider } from "../../../../Upsell/modernTS/JUI/Dialogs";
import FormSwitchTC from "../../../../../components/Forms/FormSwitchTC";
import ApiIdMapping from "./ApiIdMapping";
import MissingApiIdsInExcel from "./MissingApiIdsInExcel";
import FormAsyncTC from "../../../../../components/Forms/FormAsyncTC.tsx";
import { useWatch } from "react-hook-form";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { Link, useSearchParams } from "react-router";

export default function Eds() {
  const edsParentSalesAreaId = useWatch({ name: "eds_connection__parent_sales_area_id" });
  const [queryParameters] = useSearchParams();

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card sx={{ p: 4 }}>
        <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
          <FormSwitchTC
            name={"apiaccounts__useTest"}
            tDefault={"Gebruik test omgeving"}
            tKey={"vestigingen.form.apiaccounts.label.useTest"}
          />
          <FormTextTC name={"eds_connection__store_id"} tDefault={"Store ID"} tKey={"eds_connection__store_id"} />
          <FormAsyncTC
            async={{
              url: "core/vestigingen/search?fields=id as value, systeemNaam as label&per_page=50&sort_field=systeemNaam",
              searchField: "systeemNaam",
            }}
            name={"eds_connection__parent_sales_area_id"}
            nullable={true}
            tDefault={"Hoofd vestiging"}
            tKey={"vestigingen.form.eds.label.parent_id"}
          />
        </GridLegacy>

        {!edsParentSalesAreaId ? (
          <>
            <MissingApiIdsInExcel />
            <DialogProvider>
              <ApiIdMapping />
            </DialogProvider>
          </>
        ) : (
          <GridLegacy container spacing={1} style={{ maxWidth: 1400, paddingTop: 20 }}>
            <Alert variant={"outlined"} severity={"info"}>
              <Link
                to={`/manager/vestigingen/${edsParentSalesAreaId}/edit?tabIndex=${queryParameters.get("tabIndex")}`}
              >
                <b>
                  <TranslationWrapper tKey={"Go to parent sales area"} />
                </b>
              </Link>
              &nbsp;
              <TranslationWrapper tKey={"to modify composed ids or remove the parent sales area."} />
            </Alert>
          </GridLegacy>
        )}
      </Card>
    </div>
  );
}

export type IdRow = {
  composed_id: string;
  article_id: string;
  option_id: string;
};
